import React from 'react';
export function CierreSection() {
  return <section className="bg-[#FFFFFF] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-1">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center space-y-16" data-id="element-2">
        <div className="space-y-8" data-id="element-3">
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0F0F0F] leading-tight" data-id="element-4">
            Tu agenda está produciendo exactamente los resultados
            <br data-id="element-5" />
            que fue diseñada para producir.
          </p>

          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0F0F0F] leading-tight" data-id="element-6">
            Si no te gustan tus resultados…
            <br data-id="element-7" />
            no es esfuerzo.
            <br data-id="element-8" />
            <span className="text-[#C9A96E]" data-id="element-9">Es diseño.</span>
          </p>
        </div>

        <button className="bg-[#C9A96E] text-[#0F0F0F] font-bold text-lg md:text-xl py-4 px-10 rounded-full hover:opacity-90 transition-opacity w-full md:w-auto shadow-xl" data-id="element-10">
          DESCUBRIR MI 20% CRÍTICO
        </button>
      </div>
    </section>;
}